import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedModule } from '../../../shared/shared.module';
import { FileUploadModule } from 'ng2-file-upload';
import { ModalModule } from '../../../shared/modal/modal.module';
import { DatatableModule } from '../../../shared/datatable/datatable.module';
import { UnitDetailEditorComponent } from './unit-detail-editor.component';
import { GeoRegionSelectorModule } from '../../../shared/geo-region-selector/geo-region-selector.module';
import { FormsModule } from '@angular/forms';
import { FieldErrorDisplayModule } from '../../../shared/field-error-display/field-error-display.module';
import { ImagePreviewModule } from '../../../../directives/image-preview/image-preview.module';
import { TabbedViewChangerModule } from '../../shared/tab-changers/tabbed-view-changer/tabbed-view-changer.module';
import { MemberRowSelectorModule } from '../../members/member-row-selector/member-row-selector.module';
import { TagsModule } from '../../../shared/tags/tags.module';
import { UnitImageStreetViewDialogModule } from '../unit-image-street-view-dialog/unit-image-street-view-dialog.module';
import { MatIconModule } from '@angular/material/icon';
import { UnitImageCaptionDialogModule } from '../unit-image-caption-dialog/unit-image-caption-dialog.module';
import { ButtonModule } from '../../../shared/button/button.module';


@NgModule({
    imports: [
        SharedModule,
        FileUploadModule,
        ModalModule,
        DatatableModule,
        GeoRegionSelectorModule,
        FormsModule,
        FieldErrorDisplayModule,
        ImagePreviewModule,
        TabbedViewChangerModule,
        MemberRowSelectorModule,
        TagsModule,
        UnitImageStreetViewDialogModule,
        UnitImageCaptionDialogModule,
        MatIconModule,
        MatSlideToggleModule,
        ButtonModule,
    ],
    declarations: [UnitDetailEditorComponent],
    exports: [UnitDetailEditorComponent],
})
export class UnitDetailEditorCoreModule
{
}
